export const useSxStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      height: '100%',
    },
    topBar: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    panel: { maxWidth: '400px' },
  };
};
